import React, { useEffect, useState } from "react";
import PageAdmin from "../../../components/layouts/PageAdmin";
import { Add, Photo } from "@mui/icons-material";
import { Fab, ThemeProvider, Tooltip } from "@mui/material";
import getMuiTheme from "../../../theme/TableStyle";
import MUIDataTable from "mui-datatables";
import Loading from "../../../components/layouts/Loading";
import { getElements } from "../../../API/API";
import TableOptions from "../../../components/columns/TableOptions";
import { useNavigate } from "react-router";
import CustomCard from "../../../components/layouts/CustomCard";
import GaleriesColumns from "../../../components/columns/GaleriesColumns";

export default function GaleriesAdmin() {
	const [loading, setLoading] = useState(true);
	const [galeries, setGaleries] = useState([]);
	const columns = GaleriesColumns();
	const options = TableOptions("galeries/add");
	const navigate = useNavigate();

	useEffect(() => {
		const obtenir = async () => {
			const { result } = await getElements("galeries");
			setGaleries(result);
			setLoading(false);
		};
		obtenir();
	}, []);

	return (
		<PageAdmin
			title="Galeries"
			Icon={Photo}
			button={
				<Tooltip title="Afegir galeria">
					<Fab size="small" onClick={() => navigate("/admin/galeries/add")}>
						<Add />
					</Fab>
				</Tooltip>
			}
		>
			<CustomCard>
				<Loading loading={loading}>
					<ThemeProvider theme={getMuiTheme()}>
						<MUIDataTable data={galeries} columns={columns} options={options} />
					</ThemeProvider>
				</Loading>
			</CustomCard>
		</PageAdmin>
	);
}
